import React from 'react';
import { CTA_TARGET } from '../config';

export function PrimaryCta() {
  return (
    <div style={{ textAlign: 'center' }}>
      <a
        href={CTA_TARGET}
        style={{
          display: 'inline-block',
          padding: '14px 36px',
          background: 'var(--color-accent)',
          color: 'var(--color-bg)',
          fontWeight: 600,
          fontSize: 15,
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          textDecoration: 'none',
          border: 'none',
          minHeight: 48,
          minWidth: 48,
          borderRadius: 2
        }}
      >
        Explore the Navigator
      </a>
      <div style={{ marginTop: 'var(--space-md)' }}>
        <a href="#chief-row" style={{ color: 'var(--color-muted)', fontSize: 14, textDecoration: 'underline' }}>
          Meet the contributors
        </a>
      </div>
    </div>
  );
}
